module.exports = __webpack_public_path__ + "static/media/handbags_hero_tablet.e539b4dd.jpg";